<template>
    <div>
        <auth-container :page="page">
            <h2 class="mb-4">Contracts Expiring within 45 Days</h2>

            <b-tabs content-class="mt-4" class="page-nav-tabs">
                <b-tab>
                    <template #title>
                        Agreements
                        <b-badge :variant="data.agreements.length == 0 ? 'success' : 'danger'">{{data.agreements.length}}</b-badge>
                    </template>

                    <b-table striped responsive table-class="border-bottom table-grid" sticky-header="60vh"
                             small show-empty
                             :items="data.agreements"
                             :fields="tables.agreements">
                        <template #table-busy>
                            <div class="text-center my-4">
                                <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
                            </div>
                        </template>
                        <template #cell(edit)="data">
                            <router-link :to="`${data.item.id}`" append>
                                <font-awesome-icon :icon="['fas', 'edit']" />
                            </router-link>
                        </template>
                        <template #cell(projectNumber)="data">
                            <router-link :to="`/sr/projects/${data.item.projectId}`">{{data.value}}</router-link>
                        </template>
                        <template #cell(damId)="data">
                            <router-link :to="`/dams/${data.value}`">{{data.item.nid_id}}</router-link>
                        </template>
                        <template #cell(fundingSourceId)="data">
                            <router-link :to="`/sr/fundingsources/${data.value}`">{{data.item.fundingSource}}</router-link>
                        </template>
                        <template #empty>
                            <div class="my-2 mx-2"><em>None expiring in 45 days.</em></div>
                        </template>
                    </b-table>

                    <p class="mt-5 mb-2">
                        <strong class="mr-2">Already expired but still listed as active</strong>
                        <b-badge :variant="data.agreementsExpired.length == 0 ? 'success' : 'danger'">{{data.agreementsExpired.length}}</b-badge>
                    </p>

                    <b-table striped responsive table-class="border-bottom table-grid" sticky-header="60vh"
                             small show-empty
                             :items="data.agreementsExpired"
                             :fields="tables.agreements">
                        <template #table-busy>
                            <div class="text-center my-4">
                                <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
                            </div>
                        </template>
                        <template #cell(edit)="data">
                            <router-link :to="`${data.item.id}`" append>
                                <font-awesome-icon :icon="['fas', 'edit']" />
                            </router-link>
                        </template>
                        <template #cell(projectNumber)="data">
                            <router-link :to="`/sr/projects/${data.item.projectId}`">{{data.value}}</router-link>
                        </template>
                        <template #cell(damId)="data">
                            <router-link :to="`/dams/${data.value}`">{{data.item.nid_id}}</router-link>
                        </template>
                        <template #cell(fundingSourceId)="data">
                            <router-link :to="`/sr/fundingsources/${data.value}`">{{data.item.fundingSource}}</router-link>
                        </template>
                        <template #empty>
                            <div class="my-2 mx-2"><em>None already expired.</em></div>
                        </template>
                    </b-table>
                </b-tab>

                <b-tab>
                    <template #title>
                        Work Orders
                        <b-badge :variant="data.workOrders.length == 0 ? 'success' : 'danger'">{{data.workOrders.length}}</b-badge>
                    </template>

                    <b-table striped responsive table-class="border-bottom table-grid" sticky-header="60vh"
                             small show-empty
                             :items="data.workOrders"
                             :fields="tables.workOrders">
                        <template #table-busy>
                            <div class="text-center my-4">
                                <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
                            </div>
                        </template>
                        <template #cell(edit)="data">
                            <router-link :to="`${data.item.id}`" append>
                                <font-awesome-icon :icon="['fas', 'edit']" />
                            </router-link>
                        </template>
                        <template #cell(fundingSourceId)="data">
                            <router-link :to="`/sr/fundingsources/${data.value}`">{{data.item.fundingSource}}</router-link>
                        </template>
                        <template #empty>
                            <div class="my-2 mx-2"><em>None expiring in 45 days.</em></div>
                        </template>
                    </b-table>

                    <p class="mt-5 mb-2">
                        <strong class="mr-2">Already expired but still listed as active</strong>
                        <b-badge :variant="data.workOrdersExpired.length == 0 ? 'success' : 'danger'">{{data.workOrdersExpired.length}}</b-badge>
                    </p>

                    <b-table striped responsive table-class="border-bottom table-grid" sticky-header="60vh"
                             small show-empty
                             :items="data.workOrdersExpired"
                             :fields="tables.workOrders">
                        <template #table-busy>
                            <div class="text-center my-4">
                                <font-awesome-icon :icon="['fas', 'spinner']" spin size="2x" />
                            </div>
                        </template>
                        <template #cell(edit)="data">
                            <router-link :to="`${data.item.id}`" append>
                                <font-awesome-icon :icon="['fas', 'edit']" />
                            </router-link>
                        </template>
                        <template #cell(fundingSourceId)="data">
                            <router-link :to="`/sr/fundingsources/${data.value}`">{{data.item.fundingSource}}</router-link>
                        </template>
                        <template #empty>
                            <div class="my-2 mx-2"><em>None already expired.</em></div>
                        </template>
                    </b-table>
                </b-tab>
            </b-tabs>
        </auth-container>
    </div>
</template>

<script>
    export default {
        name: 'SrReportExpiringContracts',
        data() {
            return {
                page: {
                    errors: [],
                    loading: true,
                    showLogin: false,
                },
                data: {
                    agreements: [],
                    agreementsExpired: [],
                    workOrders: [],
                    workOrdersExpired: [],
                },
                tables: {
                    agreements: [
                        { key: 'edit', label: '', stickyColumn: true },
                        { key: 'agreementNumber', label: 'Agreement #', sortable: true },
                        { key: 'expirationDate', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') + ` (${this.timeFromNow(value)})` } },
                        { key: 'type', sortable: true },
                        { key: 'status', sortable: true },
                        { key: 'projectNumber', label: 'TPN', sortable: true },
                        { key: 'damId', label: 'NID_ID', sortable: true },
                        { key: 'fundingSourceId', label: 'Funding Source', sortable: true },
                    ],
                    workOrders: [
                        { key: 'edit', label: '', stickyColumn: true },
                        { key: 'workOrderNumber', label: 'Work Order #', sortable: true },
                        { key: 'expirationDate', sortable: true, formatter: (value) => { return this.toDate(value, 'M/D/YYYY') + ` (${this.timeFromNow(value)})` } },
                        { key: 'name', sortable: true },
                        { key: 'contractor', sortable: true },
                        { key: 'pocPrimary', label: 'POC#1', sortable: true },
                        { key: 'fundingType', sortable: true },
                        { key: 'fundingSourceId', label: 'Funding Source', sortable: true },
                        { key: 'projectType', sortable: true },
                        { key: 'projectSubtype', sortable: true },
                    ],
                }
            }
        },
        async created() {
            await this.get();
        },
        watch: {
            '$route': 'get',
        },
        methods: {
            async get() {
                this.page.errors = [];
                this.page.loading = true;

                try {
                    const response = await this.$http.get(`srreports/expiringcontracts`, this.getTokenHeader());
                    this.log(response.data);
                    this.data = response.data;
                } catch (error) {
                    if (this.isApiUnauthorized(error)) this.page.showLogin = true;
                    else this.page.errors = this.logError(error);
                }

                this.page.loading = false;
            },
        },
    }
</script>